// <<<<<<< HEAD
// // export let baseUrl="https://api.shchess.cn/"
// //
// // export let baseUrl="https://www.0shchess.ltd/"
//
//
// export let baseUrl="http://127.0.0.1:3001/"
// =======
// export let baseUrl="https://139.224.251.192/"
// >>>>>>> 5578c75d876a46454acacaffddb88d0b00106c11

export let baseUrl="https://www.0shchess.ltd/"